// Shared navigation link sets so the main Navbar and the construction
// one-pager menu stay in lockstep. If a new industry page lands, this is
// the single place to add it.

export type NavLink = {
  href: string;
  label: string;
  /** When true, the href is an external URL and should open in a new tab. */
  external?: boolean;
};

export const INDUSTRY_LINKS: NavLink[] = [
  { href: '/industries/tv-film', label: 'TV & Film' },
  { href: '/industries/construction', label: 'Construction' },
  { href: '/industries/events', label: 'Events & Festivals' },
  { href: '/industries/facilities', label: 'Facilities' },
];

export const MARKETING_SITE_URL = 'https://www.getunimo.com/';
